import BusinessCustomerVerificationButton from "./BusinessCustomerVerificationButton"

export default BusinessCustomerVerificationButton
